import React from 'react';
import styled from 'styled-components';
import { BsStarFill, BsStarHalf, BsStar } from 'react-icons/bs';
const Stars = ({ stars, reviews }) => {
  return (
    <Wrapper>
      <div className="stars">
        {Array.from({ length: 5 }, (_, index) => {
          if (index + 1 <= stars) {
            return (
              <span className='full-star'>
                <BsStarFill />
              </span>
            );
          }
          if (stars - index >= 0.5) {
            return (
              <span className='half-star'>
                <BsStarHalf />
              </span>
            );
          }

          return (
            <span className='empty-star'>
              <BsStar />
            </span>
          );
        })}
      </div>
      <p className="reviews">({reviews} customer reviews)</p>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  span {
    color: #ffb900;
    font-size: 1rem;
    margin-right: 0.25rem;
  }
  p {
    margin-left: 0.5rem;
    margin-bottom: 0;
  }
  margin-bottom: 0.5rem;
`;
export default Stars;
